import { render } from "./FragmentSidePanel.vue?vue&type=template&id=8a104412"
import script from "./FragmentSidePanel.vue?vue&type=script&lang=js"
export * from "./FragmentSidePanel.vue?vue&type=script&lang=js"
script.render = render

export default script